import * as Cesium from "cesium";

export  async function modifyBuild(viewer) {
  let tiles3d = await Cesium.createOsmBuildingsAsync();
  const osmBuildings = viewer.scene.primitives.add(tiles3d);
  //   监听当瓦片加载时候执行事件
  tiles3d.tileVisible.addEventListener(function (tile) {
    const cesium3DTileCon = tile.content;
    const featuresLength = cesium3DTileCon.featuresLength;
    for (let i = 0; i < featuresLength; i++) {
      const model = cesium3DTileCon.getFeature(i).content._model;
      console.log("model", model);
      //   修改模型的片元着色器
      const fragmentShaderSource = model._rendererResources.sourceShaders[1];
    }
  });
}
